import React, {Component} from 'react'
import styles from './NotFound.css'
import {withRouter} from "react-router-dom"

class NotFound extends Component {
  render() {
    const {match} = this.props

    const langIsDanish = Boolean(!match.params.lang)

    return (
      <div className={styles.NotFound}>
        <div className={styles.background} style={{backgroundImage: `url(/static/images/404.jpg)`}}/>
        <section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                {!langIsDanish &&
                  <article>
                    <h1>Sorry, we can't find that page</h1>
                    <a href="/" className="button primary">Go to front page</a>
                  </article>
                }
                {langIsDanish &&
                  <article>
                    <h1>Beklager, siden findes ikke</h1>
                    <a href="/" className="button primary">Gå til forsiden</a>
                  </article>
                }
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default withRouter(NotFound)


// WEBPACK FOOTER //
// ./src/templates/notfound/NotFound.js